import { css, type Theme } from "@emotion/react";

export const card = (theme: Theme) => css`
  background-image: linear-gradient(
    135deg,
    ${theme.ds5.asset.green[500]} 0%,
    ${theme.ds5.asset.grey[800]} 100%
  );
  border-radius: ${theme.ds5.radius.surface.xlarge};
  padding: ${theme.ds5.padding.dynamic[800]};
`;

export const steps = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.ds5.spacing.gap.medium};
`;

export const step = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.medium};
  padding: ${theme.ds5.padding.dynamic[600]} 0;
  border-top: ${theme.ds5.borderWeight.xsmall} solid ${theme.ds5.inverse.borderBold};
`;

export const stepNumber = css`
  flex-shrink: 0;
`;
